import { useStateValue } from "../state/State";
import { actions } from "../state/ErrorReducer";

const useErrorMessage = () => {
  const [, dispatch] = useStateValue();

  const dispatchUserFriendlyErrorMessage = (error, message) => {
    let errorMessage = "Something went wrong.";
    if (error && error.response) {
      const { status: statusCode, data: apiErrorMessage = null } = error.response;
      if (statusCode) {
        if (statusCode === 500) {
          errorMessage = "Internal server error. There was an error on the server and the request could not be completed.";
        }else if (statusCode === 503) {
          errorMessage = 'Service unavailable. The server is currently unavailable (because it is overloaded or down for maintenance).';
        } else {
          errorMessage = message ? message : apiErrorMessage ? apiErrorMessage : errorMessage;
        }
      }
      dispatch({
        type: actions.SET_ERROR,
        error: {
          error: { message: "Oops - an error occured" },
          errorInfo: { componentStack: errorMessage },
        },
      });
    }
  };

  return dispatchUserFriendlyErrorMessage;
};

export default useErrorMessage;
